import { PEOPLE_WORKING_ALL_ROLES, PEOPLE_WORKING_OTHER_ROLES } from '@rapid-recovery-agency-inc/insightt-shared';
import { SEARCH_PARAMS_VALUES } from '../../constants/app.constants';
import { createTourSection } from '../tours/helpers';
import { RolesType } from '@rapid-recovery-agency-inc/insightt-graphql';

export const PAGINATION_TAKE_AMOUNT = 10;
export const BASIC_DASHBOARD_START_HOUR = 9;

export const GET_REPOS = 'ADMIN_BASIC_DASHBOARD/GET_REPOS';
export const GET_REPOS_WITH_PREVIOUS = 'ADMIN_BASIC_DASHBOARD/GET_REPOS_WITH_PREVIOUS';
export const GET_SPOTTED = 'ADMIN_BASIC_DASHBOARD/GET_SPOTTED';
export const GET_SPOTTED_VEHICLES_WITH_PREVIOUS = 'ADMIN_BASIC_DASHBOARD/GET_SPOTTED_VEHICLES_WITH_PREVIOUS';
export const GET_REPO_HIT_LIST = 'ADMIN_BASIC_DASHBOARD/GET_REPO_HIT_LIST';
export const FETCH_LPR_SCANS = 'ADMIN_BASIC_DASHBOARD/FETCH_LPR_SCANS';
export const FETCH_PEOPLE_WORKING = 'ADMIN_BASIC_DASHBOARD/FETCH_PEOPLE_WORKING';
export const FETCH_PEOPLE_WORKING_COUNT = 'ADMIN_BASIC_DASHBOARD/FETCH_PEOPLE_WORKING_COUNT';
export const FETCH_RHL_COUNT = 'ADMIN_BASIC_DASHBOARD/FETCH_RHL_COUNT';

export const BASIC_DASHBOARD_LIST_TABS = [
  {
    label: 'Repossession Hit List',
    value: SEARCH_PARAMS_VALUES.basicDashboardListTab.repoHitList,
  },
  {
    label: 'Manual Hot List',
    value: SEARCH_PARAMS_VALUES.basicDashboardListTab.manualHotList,
  },
] as const;

export const BASIC_DASHBOARD_LIST_TABS_V2 = [
  {
    label: 'Activity Feed',
    value: SEARCH_PARAMS_VALUES.basicDashboardListTab.activityFeed,
  },
  {
    label: 'Repossession Hit List',
    value: SEARCH_PARAMS_VALUES.basicDashboardListTab.repoHitList,
  },
  {
    label: 'Manual Hot List',
    value: SEARCH_PARAMS_VALUES.basicDashboardListTab.manualHotList,
    id: createTourSection('basic-dashboard', 'manual-hot-list'),
  },
] as const;

export const PEOPLE_WORKING_TABS = [
  { label: 'All', value: PEOPLE_WORKING_ALL_ROLES, countField: 'allCount' },
  {
    label: 'Recovery Agents',
    value: RolesType.RECOVERY_AGENT,
    countField: 'recoveryAgentsCount',
  },
  {
    label: 'Spotters',
    value: RolesType.SPOTTER,
    countField: 'spottersCount',
  },
  {
    label: 'Camera Cars',
    value: RolesType.CAMERA_CAR,
    countField: 'cameraCarsCount',
  },
  {
    label: 'Others',
    value: PEOPLE_WORKING_OTHER_ROLES,
    countField: 'othersCount',
  },
] as const;

export const DASHBOARD_SWITCHER_TABS = [
  { label: 'Old', value: SEARCH_PARAMS_VALUES.basicDashboardSwitch.v1 },
  { label: 'New', value: SEARCH_PARAMS_VALUES.basicDashboardSwitch.v2 },
] as const;
